// Decorative brand marks (CEO-approved mockup 28/09/2026). Every file under
// /images/brand/art is cut from the official brand kit — never redrawn:
//   · chu-gao-nau-dung.png — tall stacked "GAO NAU" lettering
//   · goc-g.svg            — corner hairline with the G ("Dấu hiệu nhận diện")
//   · hat-gao-rac / dai-hat-gao — scattered rice grains (Visual elements)
//   · hoa-thi / dai-hoa-thi     — circle lattice (Visual elements)
//   · hat-gao.svg / hoa-4-canh.svg — single grain / four-petal flower
//   · dai-lua.svg          — the ribbon mark of Gạo Nâu Chụp Ảnh
// The PNGs only carry alpha: they are painted through CSS masks so each place
// picks its own colour (see styles/brand-art.css).
import type { CSSProperties } from "react";

const ART = "/images/brand/art";

export const BRAND_ART = {
  tallLettering: `${ART}/chu-gao-nau-dung.png`,
  cornerG: `${ART}/goc-g.svg`,
  riceScatter: `${ART}/hat-gao-rac.png`,
  riceBand: `${ART}/dai-hat-gao.png`,
  lattice: `${ART}/hoa-thi.png`,
  latticeBand: `${ART}/dai-hoa-thi.png`,
  grain: `${ART}/hat-gao.svg`,
  flower: `${ART}/hoa-4-canh.svg`,
  ribbon: `${ART}/dai-lua.svg`,
  monogramTile: "/images/brand/hoa-van-lat-kem.svg",
} as const;

type MarkProps = {
  src: string;
  className?: string;
  style?: CSSProperties;
};

/** A brand shape painted in `currentColor` (set `color` via className/style). */
export function BrandMark({ src, className = "", style }: MarkProps) {
  return (
    <span
      aria-hidden="true"
      className={`gn-mark ${className}`}
      style={{ ...style, ["--gn-src" as string]: `url(${src})` }}
    />
  );
}

type TileProps = MarkProps & {
  /** Tile edge in px. */
  size?: number;
  /** CSS gradient that fades the tile out (black = visible). */
  fade?: string;
};

/** A repeating pattern that fills its (relative) parent and fades away. */
export function BrandTile({ src, className = "", style, size, fade }: TileProps) {
  return (
    <span
      aria-hidden="true"
      className={`gn-tile ${className}`}
      style={{
        ...style,
        ["--gn-src" as string]: `url(${src})`,
        ...(size ? { ["--gn-size" as string]: `${size}px` } : {}),
        ...(fade ? { ["--gn-fade" as string]: fade } : {}),
      }}
    />
  );
}

/** A thin repeating border strip. */
export function BrandBand({ src, className = "", style, height = 10 }: MarkProps & { height?: number }) {
  return (
    <span
      aria-hidden="true"
      className={`gn-band ${className}`}
      style={{ ...style, ["--gn-src" as string]: `url(${src})`, ["--gn-h" as string]: `${height}px` }}
    />
  );
}
